<template>
  <div></div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as xhr from '../api/xhr.js'
import * as firebaseUtil from '../firebase/firebaseUtil'
import * as util from '../vendor/util'
import * as navigationState from '../vendor/navigationState'
// import * as plausi from '../vendor/plausi'
import * as qconst from '../vendor/qconstants'
import * as bootstrap from '../vendor/bootstrap'


export default {
  name: "UserLifecycle",
  data() {
    return {
      lastInitialPushCheck: 0,
    }
  },
  computed: {},
  created() {

    // setTimeout(() => {
    //     console.log('push: debug lazyRequestPush...');
    //     this.lazyRequestPush();
    // }, 4000);

    ebus.$on('logout', () => {
      this.logout();
    });

    ebus.$on('loadStempelkarte', (retry) => {
      this.loadStempelkarte(retry);
    });

    ebus.$on('lazyRequestPush', (force) => {
      this.lazyRequestPush(!!force);
    });

    ebus.$on('sendPushToken2Server', () => {
      console.log('push: on sendPushToken2Server');
      if (!!firebaseUtil.getPushToken()) {
        this.doSendPushTokenToServer(0);
        this.doSubscribeForPush();
      } else {
        console.log('push: sendPushToken2Server stopped because token is missing');
      }
    });

    // ebus.$on('pushTokenRefreshed', () => {
    //     console.log('on pushTokenRefreshed');
    //     //re-subscribe to topics
    //     this.doSubscribeForPush(null, true);
    // });

    ebus.$on('messagingReady', () => {
      console.log('push: on messagingReady');
      // this.initialPushCheck();
    });

    ebus.$on('subscribeForPush', () => {
      console.log('push: subscribeForPush...');
      this.doSubscribeForPush();
    });

    // ebus.$on('logPageView', () => {
    //     this.logPV();
    // });

    ebus.$on('checkPushPermission', ({pushType, silent}) => {
      this.checkPushPermission(pushType, silent, null, false, 'cb-pushTopic');
    });

    ebus.$on('upsertUserAccount', () => {
      this.upsertUserAccount();
    });

    ebus.$on('reloadAccountInStore', () => {
      this.reloadAccountInStore();
    });

    ebus.$on('userSignedIn', () => {
      console.log('UserLifecycle:: userSignedIn...');

      if (!firebaseUtil.isAccount()) {
        console.log('UserLifecycle:: Account unvollständig: Regitrierung noch nicht completed');
        console.log('UserLifecycle:: $route.name = ' + this.$route.name);
        if (this.$route.name === 'Anmelden') {
          this.$router.push({name: 'Registrierung'});
        }
        return;
      }

      store.commit('loggedIn', true);
      navigationState.setLoggedIn(true);

      ebus.$emit('loadStempelkarte');

      console.log('UserLifecycle userSigneIn');
      console.log('UserLifecycle duringRegistration=' + store.state.duringRegistration);
      console.log('UserLifecycle loginPostprocessing=' + store.state.loginPostprocessing);

      // ebus.$emit('loadCoupons'); // fuid required to load referralprograms

      if (store.state.duringRegistration) {
        this.upsertUserAccount();
        // firebaseUtil.gevent('sign_up_completed');
        return;
      }

      setTimeout(() => {
        let user = firebaseUtil.getUser();
        let fuid = user.uid;

        console.log('UserLifecycle userSignedIn fuid: ' + fuid);

        firebaseUtil.setUserId(fuid);

        // this.lazyCreateStripeBuyer(fuid);
        // this.$notify({
        //     type: 'info',
        //     title: 'Anmeldung erfolgreich!',
        //     text: ''
        // });

        ebus.$emit('pullBuyersProfile', fuid);

        setTimeout(() => {
          // this.getUserSettings(fuid);
          // this.loadCoupons();
        }, 1200);//give getBaseContext a bit time time init restId

        // if (store.getters.referralPrograms.length === 0) {
        //     this.loadCoupons(store.getters.restId);
        // } else {
        //     this.removeCouponsAlreadyRedeemed(fuid);
        //     this.filterIcoupons(fuid);
        //     this.lazyShowInvitationAndPromo();
        // }


        if (store.state.loginPostprocessing) {
          store.commit('loginPostprocessing', false);

          firebaseUtil.gevent('login');

          //pullAppUser calls upsertUserAccount()
          this.pullAppUser(fuid, true);

          // ebus.$emit('showInfo', {
          //     title: 'Die Anmeldung war erfolgreich',
          //     // text: '',
          // });

          let name = '';
          if (user.displayName && user.displayName.length > 0) {
            name = ' ' + user.displayName;
          }

          if (this.$ls.get('registerFB')) {
            ebus.$emit('info', 'Die Facebook-Anmeldung war erfolgreich ' + name + '. ' +
              'Vervollständige nun die Registrierung.');
            this.$router.push({name: 'Registrierung'});
            this.$ls.remove('registerFB');
          } else {
            ebus.$emit('info', 'Angemeldet als ' + name);
            if (this.$ls.get('gotoSummaryAfterAccount')) {
              this.$ls.remove('gotoSummaryAfterAccount');
              this.$router.push({name: 'Korb'});
            } else {
              ebus.$emit('gotoStart');
            }

            // this.gotoStart();

            // setTimeout(() => {
            // this.shiftFavsToUser();
            // }, 4200);
          }
          // this.$notify({
          //     type: 'success',
          //     title: 'Anmeldung erfolgreich',
          //     text: name
          // });
        } else {
          this.upsertUserAccount();
        }

      }, 400);
      // this.$router.push({name: 'Home'});
    });

    ebus.$on('userSignedOut', () => {
      store.commit('loggedIn', false);

      navigationState.setLoggedIn(false);

      console.log('UserLifecycle userSignedOut');

      if (store.state.isLoggingOut) {
        store.commit('isLoggingOut', false);

        ebus.$emit('info', 'Die Abmeldung war erfolgreich');

        // this.$notify({
        //     type: 'success',
        //     title: 'Abmeldung erfolgreich',
        //     text: name
        // });

        // this.gotoStart();
        // ebus.$emit('showInfo', {
        //     title: 'Die Abmeldung war erfolgreich',
        //     // text: '',
        // });
      }

      // this.$router.push({name: 'Home'});
    });

    // ebus.$on('saveUserSettings', () => {
    //   this.saveUserSettings();
    // });

    ebus.$on('regCompleted', () => {
      //
      //     //make friends
      //     let bivtr = this.$ls.get('bivtr');
      //     if (bivtr) {
      //         let friendUid = bootstrap.getBtaste();
      //         let friendFuid = firebaseUtil.getFuid();
      //
      //         let msg = {
      //             action: qconst.action$MakeFriends,
      //             ivtr: bivtr,
      //             friendUid: '' + friendUid,
      //             friendFuid: '' + friendFuid,
      //         };
      //
      //         xhr.xhrSend(true, msg, (reply) => {
      //             if (reply.ok) {
      //                 console.log('Make friends completed!');
      //                 this.$ls.remove('bivtr');
      //             }
      //         }, (err) => {
      //             console.log('??? error making friends: ' + JSON.stringify(err));
      //         });
      //     }
      //
      setTimeout(() => {
        ebus.$emit('loadFuidPoints');
        // this.lazyShowNewCoupons();
        // this.loadCoupons();
      }, 900);
      //     setTimeout(() => {
      //         this.gotoCoupons();
      //     }, 1200);
      //
    });

  },
  mounted() {
    if (!store.state.enableAccount) {
      store.commit('loggedIn', false);
    }
    // setTimeout(() => {
    //     this.initialPushCheck();
    // }, 20 * 1000);
    //enable analytics after DSKVO in finishDsgvo
    // firebaseUtil.initAnalytics();
  },
  methods: {
    doSendPushTokenToServer(numberOfRetry) {
      ++numberOfRetry;
      let token = firebaseUtil.getPushToken();
      let msg = {
        action: qconst.action$DocUpserter,
        updates: {
          deviceId: bootstrap.getBtaste(),
          pushToken: token,
        },
        collectionName: 'pushTokens',
        // prefix: 'shop_',
        subjectKey: {
          key: 'deviceId',
          value: bootstrap.getBtaste(),
        },
        autoRetry: true,
      };
      xhr.xhrSend(true, msg, (reply) => {
        if (reply && reply.ok) {
          console.log('push: pushToken saved successfully ' + token);
        } else {
          if (numberOfRetry < 10) {
            //retry
            setTimeout(() => {
              console.log('push: retry save pushToken');
              this.doSendPushTokenToServer(numberOfRetry);
            }, 4000);
          }
        }
      });
    },
    loadStempelkarte(params) {
      if (!store.getters.enableStempel || !store.getters.loggedIn) {
        return;
      }

      let fuid = firebaseUtil.getFuid();
      if (!fuid) {
        if (params.retry) {
          //retry
          setTimeout(() => {
            this.loadStempelkarte();
          }, 4 * 1000);
        }
        return;
      }

      console.log('going go load stempelkarte for fuid ' + fuid);
      let msg = {
        action: qconst.action$LoadStempelkarte,
        fuid: fuid,
      };
      xhr.xhrSend(true, msg, (data) => {
        if (data && data.ok && data.stempelkarte) {
          store.commit('stempelkarte', data.stempelkarte);
        } else {
          console.error('user has no stempelkarte yet');
          store.commit('stempelkarte', {
            fuid: fuid,
            punktestand: 0,
          });
        }
        console.log('Stempelkarte loaded successfully')
        console.log('emit stempelkarteWasUpdated...');
        ebus.$emit('stempelkarteWasUpdated');
        ebus.$emit('stempelkarteBigWasUpdated');
      }, (err) => {
        if (params?.retryOnError) {
          setTimeout(() => {
            this.loadStempelkarte();
          }, 3 * 1000);
        }
        console.log('??? Exception in loadStempelkarte: ' + err.message);
      });
    },

    lazyRequestPush(force) {
      if (!!firebaseUtil.getPushToken()) {
        this.doSendPushTokenToServer(0);
        this.doSubscribeForPush();
      } else {
        firebaseUtil.requestPushToken(!force);//silent
      }
    },

    doSubscribeForPush() {
      let pt = firebaseUtil.getPushToken();
      if (!!pt) {
        this.$store.commit('appSettings', {pushToken: pt});
      } else {
        pt = store.getters.appSettings.pushToken;
      }
      if (!!pt) {
        ebus.$emit('saveAppSettings');
      }

      console.log('doSubscribeForPush with pushToken ' + pt);

      // try {
      //     let topics = null;
      //     if (pushTopics) {
      //         topics = util.cloneMe(pushTopics);
      //     } else {
      //         topics = util.cloneMe(store.state.appSettings.pushTopics);
      //     }
      //     // console.log('doSubscribeForPush... topics', topics);
      //     let _this = this;
      //
      //     // firebaseUtil.requestPushToken(true);//silent
      //
      //     //give requestPushToken 5 seconds
      //     setTimeout(() => {
      //         let pt = firebaseUtil.getPushToken();
      //         if (navigator.onLine && firebaseUtil.hasMessaging() && pt) {
      //             console.log('development break doSubscribeForPush')
      //             //FIXME enable topics
      //             // navigator.serviceWorker.ready.then(function (swRegistration) {
      //             //     console.log('subscribe endpoint available');
      //             //     ebus.$emit('saveAppSettings', {//will subscribe and unsubscribe automatically
      //             //         pushToken: pt,
      //             //         pushTopics: topics,
      //             //         withRetry: withRetry
      //             //     });
      //             //     // _this.saveAppSettings({//will subscribe and unsubscribe automatically
      //             //     //     pushToken: pt,
      //             //     //     pushTopics: topics
      //             //     // });
      //             // })
      //         } else {
      //             //retry
      //             setTimeout(() => {
      //                 if (this.hasPushTopics()) {
      // firebaseUtil.requestPushToken(true);//silent
      //                 }
      //                 this.doSubscribeForPush(topics);
      //             }, 9000);
      //         }
      //     }, 5000);
      //
      // } catch (e) {
      //     console.log('Error in doSubscribeForPush: ' + e.message);
      // }
    },
    async pullAppUser(fuid, withUpsert) {
      console.log('UserLifecycle pullAppUser for ' + fuid);
      // let msg = {
      //     action: qconst.action$LoadAppUser,
      //     fuid: fuid,
      // };
      //
      // //Send
      // xhr.xhrSend(true, msg, (response) => {
      //     console.log('UserLifecycle pullAppUser response:', response);
      //     if (response && response.ok && response.appUser) {
      //
      //         //write the address to localStorage
      //         if (response.appUser.invoiceAddress) {
      //             let ia = response.appUser.invoiceAddress;
      //             if (ia.street && ia.street.length > 0) {
      //                 this.localStoreInvoiceAddress(ia);
      //                 // this.$ls.set('invoiceAddress', JSON.stringify(ia));
      //             }
      //         }
      //         if (response.appUser.deliveryAddress) {
      //             let da = response.appUser.deliveryAddress;
      //             if (da.street && da.street.length > 0) {
      //                 this.localStoreDeliveryAddress(da);
      //                 // this.$ls.set('deliveryAddress', JSON.stringify(da));
      //             }
      //         }
      //     }
      if (withUpsert) {
        this.upsertUserAccount();
      }
      // }, (err) => {
      //     console.log('Error loading appUser: ' + err);
      // });
    },

    upsertUserAccount() {//only with fuid
      console.log('UserLifecycle upsertUserAccount');

      let _user = firebaseUtil.getUser(); // firebase user object
      if (!_user) {
        return;
      }
      let upsertMsg = {
        action: qconst.action$UpsertAppUser,
        fuid: _user.uid,
        name: _user.displayName,
        email: _user.email,
        phone: '' + _user.phoneNumber,
        providerId: '' + _user.providerId,
        emailVerified: _user.emailVerified,
      };

      //Decide if appuser has an account depending on the values of appuser
      console.log('UserLifecycle users name=' + upsertMsg.name);
      console.log('UserLifecycle users email=' + upsertMsg.email);
      console.log('UserLifecycle users phoneNumber=' + upsertMsg.phone);

      try {

        let isAccount = firebaseUtil.isAccount();
        // && 'deliveryAddress' in upsertMsg
        // && upsertMsg.deliveryAddress.plz.length > 0
        // && upsertMsg.deliveryAddress.street.length > 0
        // && upsertMsg.deliveryAddress.city.length > 0
        this.$ls.set('hasAccount', isAccount);

        console.log('UserLifecycle upsertUserAccount isAccount=' + isAccount);

        if (isAccount) {
          // this.lazyCreateStripeBuyer(_user.uid);

          this.$ls.remove('registerFB');

          let ia = this.getInvoiceAddress();
          if (ia && ia.street && ia.street.length > 0) {
            upsertMsg.invoiceAddress = da;
          }

          let da = this.getDeliveryAddress();
          if (da && da.street && da.street.length > 0) {
            upsertMsg.deliveryAddress = da;
          }

          // if (upsertMsg.deliveryAddress) {
          //     this.acceptInvitation(upsertMsg.deliveryAddress.plz);
          // }

          // xhr.xhrSend(false, upsertMsg);
          xhr.xhrSend(true, upsertMsg, (response) => {
            this.reloadAccountInStore();
          }, (err) => {
            ebus.$emit('failed-upsertUserAccount');
          });
        } else {
          console.log('UserLifecycle account is incomplete');
          ebus.$emit('failed-upsertUserAccount');
        }
      } catch (e) {
        console.log('UserLifecycle error in isAccount: ' + e.message);
        store.commit('showLoading', false);
      }
    },

    getInvoiceAddress() {
      let fd = this.$ls.get('formData') || {};
      if (fd.invoiceAddress) {
        return fd.invoiceAddress;
      }
      return null;
    },

    getDeliveryAddress() {
      let fd = this.$ls.get('formData') || {};
      if (fd.deliveryAddress) {
        return fd.deliveryAddress;
      }
      return null;
    },

    reloadAccountInStore() {
      let _user = firebaseUtil.getUser();
      if (_user) {
        let user = this.getUserFromFirebase(_user);
        store.commit('user', user);
        store.commit('loggedIn', true);
        ebus.$emit('loadStempelkarte');
        console.log('??? account reloaded');
        ebus.$emit('accountUpdated');
        // this.$notify({
        //     type: 'info',
        //     title: 'Willkommen zurück!',
        //     text: ''
        // });
      }
    },

    getUserFromFirebase(fbUser) {
      let user = {
        fuid: fbUser.uid,
        name: fbUser.displayName,
        email: fbUser.email,
        emailVerified: fbUser.emailVerified,
        phone: fbUser.phoneNumber
      };
      // if (!user.name || user.name.length === 0) {
      //     user.name = 'Gast Account'
      // }
      return user;
    },

    //key = fuid
    saveUserSettings() {
      // // let favDrinks = util.cloneMe(store.state.userSettings.favcartsApp.drinks);
      // let favFoods = util.cloneMe(store.state.userSettings.favcartsApp.foods);
      // console.log('save favFoods: ', favFoods);
      // // localStorage.setItem('favDrinks' + restId, JSON.stringify(favDrinks));
      // this.$ls.set('favFoods', favFoods);
      // // this.notifyLoginRequired();
      //
      //
      // if (!firebaseUtil.getUser()) {
      //   return;
      // }
      //
      // let msg = {
      //   action: qconst.action$SaveUserSettings,
      //   allergenes: util.cloneMe(store.state.userSettings.allergenes),
      //   favcartsApp: util.cloneMe(store.state.userSettings.favcartsApp),
      //   fuid: firebaseUtil.getUser().uid,
      //   // restaurantId: restId,
      //   // appId: bootstrap.appId
      //   // favcartsApp:  util.cloneMe(store.state.userSettings.favcartsApp)
      // };
      //
      // //Send
      // xhr.xhrSend(true, msg, (response) => {
      //   // ebus.$emit('info', 'Einstellungen erfolgreich gespeichert');
      //   console.log('userSettings saved');
      // }, (err) => {
      //   console.log('??? Error saving userSettings: ' + err);
      // });
    },

    checkPushPermission(pushType, silent, yAction, forceQuestion, qCallback) {
      // if (!navigator.onLine || !firebaseUtil.hasMessaging()) {
      //     return;
      // }
      //
      // // if(!firebaseUtil.getSupportsPush()){
      // //     ebus.$emit('showQuestion', {
      // //         quest: quest,
      // //         yesAction: 'initMessaging',
      // //         yesLabel: yesLabel
      // //     })
      // // }
      //
      //
      // if (forceQuestion || !firebaseUtil.getPushToken()) {
      //     // if (qCallback) {
      //     //     this.currentCallback = qCallback
      //     // }
      //
      //     let quest = '';
      //     let yesAction = null;//'requestPush';
      //     let yesLabel = 'Ja, zulassen';
      //     this.currentPushType = pushType;
      //     if (pushType === '0') {
      //         quest = 'Möchtest du über Aktuelles benachrichtigt werden?';
      //         yesLabel = 'Ja';
      //     } else if (pushType === '1') {
      //         quest = 'Möchtest du über aktuelle Produkte, Angebote & Aktionen von ' + store.state.brandName + ' benachrichtigt werden?';
      //         // } else if (pushType === '2') {
      //         //     quest = 'Möchtest du über Statusänderungen deiner Bestellung benachrichtigt werden?';
      //     } else if (pushType === '2') {
      //         quest = 'Möchtest du aktuelle Coupons erhalten, welche du in teilnehmenden Filialen von ' + store.state.brandName + ' einlösen kannst?';
      //         // quest = 'Möchtest du Coupons erhalten, welche du im Online-Shop einlösen kannst?';
      //     } else if (pushType === '3') {
      //         quest = 'Möchtest du Treuepunkte sammeln und exklusive Angebote erhalten?';
      //     }
      //
      //     if (yAction) {
      //         yesAction = yAction;
      //     }
      //
      //     ebus.$emit('showQuestion', {
      //         quest: quest,
      //         yesAction: yesAction,
      //         yesLabel: yesLabel,
      //         noLabel: null,
      //         cb: qCallback
      //     })
      // } else {
      //     if (qCallback) {
      //         ebus.$emit(qCallback, 'yes');
      //     } else {
      //         firebaseUtil.requestPushToken(silent);//silent
      //     }
      // }
    },

    initialPushCheck() {
      // if (!firebaseUtil.hasMessaging()) {
      //     console.log('push: initialPushCheck exit because no messaging');
      //     return;
      // }
      // if (util.isEmptyObject(store.state.appSettings.pushTopics)) {
      //     console.log('push: initialPushCheck exit because appSettings is not loaded yet');
      //     return;
      // }
      // console.log('push: initialPushCheck...');
      //
      // let now = new Date().getTime();
      // if ((now - this.lastInitialPushCheck) < 60000) {
      //     //prevent double execution of initialPushCheck
      //     return;
      // }
      //
      // this.lastInitialPushCheck = now;
      //
      // if (this.hasPushTopics()) {
      //     firebaseUtil.requestPushToken(true);
      //     setTimeout(() => {
      //         if (!firebaseUtil.getPushToken()) {
      //             //Device has lost the pushToken. So lets request the token again
      //             // this.checkPushPermission('0', false, 'gotoSettings');
      //             if (navigator.onLine) {
      //                 firebaseUtil.requestPushToken(false);//not silent
      //             }
      //         } else {
      //             this.doSubscribeForPush(store.state.appSettings.pushTopics);
      //         }
      //     }, 5000);
      // } else {
      //     setTimeout(() => {
      //         // let usage = this.$ls.get('appUsage', 0);
      //         let tau = this.getTotalAppUsage();
      //         //ask for push not before 30 seconds
      //         if (tau > (30 * 1000)) {
      //             this.checkPushPermission('0', true, 'gotoSettings', true);
      //         } else {
      //             this.initialPushCheck();
      //         }
      //     }, 10 * 1000);
      // }
    },

    hasPushTopics() {
      let pushTopics = JSON.stringify(store.getters.appSettings.pushTopics);
      console.log('push: hasPushTopics: ' + pushTopics);
      return pushTopics.indexOf('true') !== -1;
    },

  }// eof methods
}
</script>

<style scoped>

</style>
